import { SVG, SVGProps } from './svg'

export function IconArrowForward(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M2 12.5v-1a.5.5 0 0 1 .5-.5h16.17l-4.45-4.44a.5.5 0 0 1 0-.71l.71-.7a.5.5 0 0 1 .71 0l6.14 6.13c.14.14.22.331.22.53v.38a.77.77 0 0 1-.22.53l-6.14 6.13a.5.5 0 0 1-.71 0l-.71-.71a.49.49 0 0 1 0-.7L18.67 13H2.5a.5.5 0 0 1-.5-.5Z" />
    </SVG>
  )
}
